import React, { FunctionComponent } from 'react';

const FiltersGroup: FunctionComponent = (props) => <div className="Filters__group" {...props} />;

export default FiltersGroup;
